
document.addEventListener("DOMContentLoaded", function() {
    let heroAni = gsap.timeline().from('.media_banner_with_text .group-block > *', { opacity: 0, y: 30, duration: 0.5, stagger: 0.3 })
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
        trigger: '.text-with-image-animation ',
        start: 'top 50%',
        end: 'bottom top',
        scrub: false,
        markers: false,
        onEnter: () => {
            let tl = gsap.timeline();
            document.querySelector('.text-with-image-animation').classList.add('active');
            // Example fix:
            tl.fromTo('.text-with-image-animation .blank-block', { height: '100%' }, { height: '0', duration: 3, ease: 'ease-in-out', delay: 0.8 },  '< 0');
            tl.fromTo('.text-with-image-animation .text-block', { opacity: 0.5, y: 50, duration: 3 }, { opacity: 1, y: 0, duration: 3 }, '< 0');
        }
    });
});